import React, { useState } from 'react';
import { register } from '../api/auth';

export default function Register() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [registrationToken, setRegistrationToken] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const { token } = await register(email, password, registrationToken);
      localStorage.setItem('token', token);
      window.location.href = '/';
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-8">
              <div className="w-full max-w-md">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <img
            src="/budgie_logo_sm.png"
            alt="Budgie Logo"
            className="h-16 object-contain"
            style={{ maxWidth: 120 }}
          />
        </div>

        {/* Heading */}
        <h1 className="text-2xl font-bold mb-8 text-center text-gray-900">Sign Up</h1>

        {/* Form */}
        <form onSubmit={handleSubmit} className="flex flex-col gap-5">
          <label className="flex flex-col gap-2">
            <span className="text-sm font-medium text-gray-700">Email</span>
            <input 
              type="email" 
              className="rounded-full px-4 py-3 border border-gray-200 bg-gray-50 text-base font-medium text-gray-800 focus:outline-none focus:border-green-500 focus:bg-white transition-colors" 
              value={email} 
              onChange={e => setEmail(e.target.value)} 
              required 
            />
          </label>
          
          <label className="flex flex-col gap-2">
            <span className="text-sm font-medium text-gray-700">Password</span>
            <input 
              type="password" 
              className="rounded-full px-4 py-3 border border-gray-200 bg-gray-50 text-base font-medium text-gray-800 focus:outline-none focus:border-green-500 focus:bg-white transition-colors" 
              value={password} 
              onChange={e => setPassword(e.target.value)} 
              required 
            />
          </label>
          
          <label className="flex flex-col gap-2">
            <span className="text-sm font-medium text-gray-700">Registration Token</span>
            <input 
              type="text" 
              className="rounded-full px-4 py-3 border border-gray-200 bg-gray-50 text-base font-medium text-gray-800 focus:outline-none focus:border-green-500 focus:bg-white transition-colors" 
              value={registrationToken} 
              onChange={e => setRegistrationToken(e.target.value)} 
              required 
            />
          </label>
          
          {error && (
            <div className="text-red-500 text-center text-sm bg-red-50 py-2 px-3 rounded-lg">
              {error}
            </div>
          )}
          
          <button 
            type="submit" 
            className="w-full py-3 rounded-full bg-[#22C55E] text-white text-lg font-semibold mt-4 hover:bg-green-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" 
            disabled={loading}
          >
            {loading ? 'Creating account...' : 'Register'}
          </button>
        </form>
        
        <div className="text-center text-sm mt-6 text-gray-600">
          Already have an account?{' '}
          <a href="/login" className="text-[#22C55E] font-semibold hover:text-green-600 transition-colors">
            Login
          </a>
        </div>
      </div>
    </div>
  );
} 